import React, { FC } from "react";
import classNames from "classnames";
import { Fade } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";
import { DEFAULT_FADE_DURATION } from "@app/constants";

type Benefit = {
  title: string;
  body: string;
};

export const Benefits: FC = () => {
  const { t } = useTranslation("p_bank_apple-pay");

  return (
    <div
      className={classNames(
        "mt-20 flex flex-col gap-10",
        "md:flex-row",
        "lg:mt-25",
        "xl:mt-40 xl:max-w-container xl:flex-col xl:items-center xl:gap-0",
      )}
    >
      <Fade
        duration={DEFAULT_FADE_DURATION}
        triggerOnce
        className={classNames(
          "md:flex-1",
          "xl:max-w-[66%] xl:flex-none xl:border-t xl:border-divider last:xl:border-b",
        )}
        cascade
      >
        {(t("benefits", { returnObjects: true }) as Benefit[]).map(
          (benefit) => (
            <div
              key={benefit.title}
              className="xl:flex xl:justify-between xl:py-12"
            >
              <h3
                className={classNames(
                  "mb-2.5 text-regular text-primary-content",
                  "lg:mb-5 lg:text-medium",
                  "xl:mb-0 xl:w-[38%] xl:text-large",
                )}
              >
                {benefit.title}
              </h3>
              <p
                className={classNames(
                  "text-regular text-base-400",
                  "xl:w-[48%] xl:text-medium",
                )}
              >
                {benefit.body}
              </p>
            </div>
          ),
        )}
      </Fade>
    </div>
  );
};
